<template>
  <div class="x-upload-container">
    <div class="x-upload-top-tip-wrapper">
      <slot name="topTip"></slot>
    </div>
    <el-upload
        ref="upload"
        class="x-upload"
        v-bind="$attrs"
        v-on="$listeners"
        :action="action"
        :accept="accept"
        :list-type="listType"
        :file-list="realFileList"
        :limit="limit"
        :multiple="realMultiple"
        :class="{ 'hide-upload-trigger': hideUploadTrigger, 'show-file-name': showFileName }"
        :httpRequest="httpRequestForUpload"
        :on-exceed="handleExceed"
        :on-success="handleOnSuccess"
        :before-upload="handleBeforeUpload"
        :on-error="handleOnError"
        :on-progress="handleOnProgress"
        :on-preview="(file) => {handlePreviewFile({file})}"
    >
      <template v-slot:file="{ file }" v-if="listType === 'picture-card'">
        <div class="img-wrapper">
          <img
              class="el-upload-list__item-thumbnail"
              :src="getFileThumbnail({file})"
              alt=""
          />
          <div class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePreviewFile({ file })">
            <i class="el-icon-zoom-in"></i>
          </span>
            <span
                v-if="$attrs.disabled !== true"
                class="el-upload-list__item-delete"
                @click="handleFileRemove({ file })"
            >
            <i class="el-icon-delete"></i>
          </span>
          </div>
        </div>
        <el-tooltip effect="dark" :content="file.name" placement="bottom">
          <p class="file-name" v-if="showFileName">{{getFileName(file)}}</p>
        </el-tooltip>
      </template>
      <template v-slot:trigger v-if="$attrs.disabled !== true">
        <div v-if="listType === 'picture-card'">
          <div class="el-upload--picture-card-box">
            <slot name="trigger">
              <template>
                <XIcon
                    v-if="remoteUploadUrl"
                    :icon="icon"
                    color="currentColor"
                    class="qr-code-icon"
                    @click.stop="handleQRCode"
                ></XIcon>
                <i class="el-icon-plus"></i>
                <el-dialog
                    title="扫描二维码"
                    class="x-renew-process__invoice"
                    :visible.sync="visible"
                    width="300"
                    height="300"
                    @close="handleClearInterval"
                    :close-on-click-modal="false"
                >
                  <div style="text-align: center">请用手机扫码操作</div>
                  <div class="qr-code-wrapper">
                    <vue-qr v-if="qrUrl" :text="qrUrl" :size="200"></vue-qr>
                    <div v-if="qrCodeExpire" class="qr-code-expire" @click="handleQRCode">
                      <div class="qr-code-expire-wrapper">
                        <XIcon class="x-login-qr__icon" name="el-icon-refresh-left"></XIcon>
                        <div class="x-login-qr__action">刷新</div>
                        <div class="x-login-qr__text">二维码已失效</div>
                        <div class="x-login-qr__text">请刷新后重试</div>
                      </div>
                    </div>
                  </div>
                </el-dialog>
              </template>
            </slot>
          </div>
          <div class="uploadTip" :class="uploadTipClass" v-if="uploadTip">{{ uploadTip }}</div>
        </div>
        <template v-if="listType=== 'text'">
          <el-button type="primary">点击上传</el-button>
        </template>
      </template>
      <template v-slot:tip v-if="tip">
        <div class="el-upload__tip" v-html="tip"></div>
      </template>
    </el-upload>
  </div>
</template>

<script>
import { Upload, Loading, Notification, Tooltip } from 'element-ui';
import ajax from 'element-ui/packages/upload/src/ajax';
import {beforeUploadCheckType, getFileThumbnail, handleError, previewFile} from '@/util/componentUtil';
import * as appUtils from '@/util/appUtils';
import request from '@/util/request2';
// import { checkQrCode, createQrCode } from '../../api/XUploadFileApi';
import { uuid } from '@/util/util';
import QrCodeLogin from '@/icon/QrCodeLogin';
import VueQr from 'vue-qr';
// import Cover from './components/Cover';
import {injectSessionKey, injectToken} from '@/util/user';
// import { Minio } from '@/util/Minio';
// import md5 from 'md5';
const checkQrCode = () => {};
const createQrCode = () => {};
// 先用空函数替代
const getFileUrlByFilePath = () => {};
// const minio = new Minio(
//   {},
//   {
//     reuse: false,
//     createMd5: ({ buffer, file }) => {
//       const { lastModifiedDate = Date.now(), lastModified = Date.now(), name, size, type } = file;
//       return md5(
//         String(name) + String(lastModifiedDate) + String(lastModified) + String(size) + String(type)
//       ).toString();
//     }
//   }
// );
/**
 * 编辑模式
 * @type {string}
 */
export const MODE_EDIT = 'edit';
/**
 * 查看模式
 * @type {string}
 */
export const MODE_VIEW = 'view';
export default {
  name: 'XUpload',
  inheritAttrs: false,
  components: {
    [Upload.name]: Upload,
    VueQr,
    // Cover,
    [Tooltip.name]: Tooltip
  },
  props: {
    uploadTipClass: {
      type: String,
      default: ''
    },
    /**
     * 上传提示
     */
    uploadTip: {
      type: String,
      default: ''
    },
    /**
     * 是否显示文件名
     */
    showFileName: {
      type: Boolean,
      default: true
    },
    /**
     * 是否通过接口获取文件名
     */
    isGetNameFromRemote: {
      type: Boolean,
      default: true
    },
    action: {
      type: String,
      default: '/api/auth/sysFile/uploadFile'
    },
    limit: Number,
    /**
     * 上传后的文件数据转换函数，如将上传后的文件数据转换成表单的数据
     */
    convertUploadFiles: Function,
    /**
     * 上传前的校验，与el-upload的beforeUpload不同，这个beforeUpload函数可以返回一个boolean值，
     * 也可以返回一个{valid: true/false， message: string}的对象，或者返回一个promise。
     * 扩展{valid: true/false， message: string}主要是为了统一输出提示信息
     */
    beforeUpload: Function,
    /**
     * 删除文件前的校验，与el-upload的beforeRemove不同，这个beforeRemove函数可以返回一个boolean值，
     * 也可以返回一个{valid: true/false， message: string}的对象，或者返回一个promise。
     * 扩展{valid: true/false， message: string}主要是为了统一输出提示信息
     */
    beforeRemove: Function,
    onRemove: Function,
    /**
     * 可接受的文件类型
     */
    accept: String,
    /**
     * 文件大小，单位B
     */
    size: [Number, String],
    /**
     * 提示性文字
     */
    tip: String,
    listType: {
      type: String,
      default: 'text'
    },
    fileList: {
      type: Array,
      default() {
        return [];
      }
    },
    onSuccess: Function,
    onError: Function,
    onProgress: Function,
    queryUrl: {
      type: String,
      default: '/api/sysFile/getByIds'
    },
    queryMethod: {
      type: String,
      default: 'get'
    },
    /**
     * 跨端上传url
     */
    remoteUploadUrl: String,
    objectConverter: {
      type: Object,
      default: () => {
        return null;
      }
    },
    multiple: {
      type: Boolean,
      default: undefined
    },
    expire: {
      type: Number,
      default: 5
    },
    isMinIo: Boolean, // 是否使用 minio 上传
    /**
     * 是否显示trigger，即新增按钮
     * auto: 自动显示，默认
     * show: 一直显示
     * hide: 一直不显示
     */
    triggerVisibility: {
      type: String,
      default: 'auto'
    },
    httpRequest: Function,
    /**
     * 预览模式， 如['pdf'],就支持pdf预览
     */
    previewMode: {
      type: Array,
      default: () => { return ['pdf']; }
    }/*,
    mode: {
      type: String,
      default: 'edit'
    }*/
  },
  data() {
    return {
      // 已上传的文件列表
      uploadFiles: [],
      visible: false,
      loading: true,
      qrUrl: '',
      realFileList: [],
      icon: QrCodeLogin,
      qrCodeExpire: false,
      httpRequestForUpload: undefined
    };
  },
  created() {
    this.uploadCode = '';
    this.intervalId = 0;
    this.loadingOption = {
      spinner: 'el-icon-loading',
      fullscreen: true,
      background: 'rgba(255, 255, 255, 0)',
      customClass: 'custom-loading'
    };
    this.httpRequestForUpload = this.httpRequest;
    if (!this.httpRequestForUpload) {
      this.httpRequestForUpload = (options) => {
        if (!options.headers) {
          options.headers = {};
        }
        injectToken({headers: options.headers});
        injectSessionKey({headers: options.headers});
        return ajax(options);
      }
    }
    // this.initMinIo();
  },
  methods: {
    /*initMinIo() {
      if (this.isMinIo && !this.httpRequest) {
        this.httpRequestForUpload = data => {
          if (this.beforeUpload && !this.beforeUpload()) return false;
          const uploadFiles = this.$refs.upload.uploadFiles;
          const file = uploadFiles[uploadFiles.length - 1];
          minio
            .upload(data.file, data.data)
            .then(res => {
              const response = {
                code: 1,
                data: res,
                msg: '上传成功',
                success: true
              };
              file.status = 'done';
              file.response = response;
              this.handleOnSuccess(response, file, uploadFiles);
            })
            .catch(e => {
              console.error(e);
              throw e;
            });
        };
      }
    },*/
    getFileName(file) {
      if (file.srcFileName) {
        return file.srcFileName;
      }
      if (file.response && file.response.data && file.response.data.srcFileName) {
        return file.response.data.srcFileName;
      }
      return file.name;
    },
    handleQRCode() {
      // 先清空checkQrCode
      this.handleClearInterval();
      const uploadCode = uuid();
      let limitType = '';
      if (this.accept) {
        const arr = this.accept.split(',');
        const newArr = [];
        for (const item of arr) {
          if (item.startsWith('.')) {
            newArr.push(item.substring(1));
          } else {
            newArr.push(item);
          }
        }
        limitType = newArr.join(',');
      }
      const uploadFiles = this.$refs.upload.uploadFiles;
      // 跨端上传的数量限制为需要this.limit减去已上传的数量
      let limit = 1;
      if (this.limit) {
        limit = this.limit - uploadFiles.length;
      }
      const url = `${this.remoteUploadUrl}?maxSize=${
        this.size ? this.size : 10 * 1024 * 1024
      }&maxCount=${limit}&limitType=${limitType}&uploadCode=${uploadCode}`;
      createQrCode({ uploadCode, url, expire: this.expire }).then(response => {
        const res = response.data;
        if (res.isFail()) {
          Notification.error(res.msg);
          return;
        }
        const data = res.data;
        this.uploadCode = data.uploadCode;
        this.qrUrl = data.qrUrl;
        this.qrCodeExpire = false;
        this.visible = true;
        this.intervalId = setInterval(this.checkQrCode, 1000);
      });
    },
    handleClearInterval() {
      clearInterval(this.intervalId);
      this.intervalId = 0;
    },
    checkQrCode() {
      checkQrCode({ uploadCode: this.uploadCode }).then(response => {
        const res = response.data;
        if (res.isFail()) {
          Notification.error(res.msg);
          if (res.code === 412) {
            // 二维码过期
            this.qrCodeExpire = true;
          }
          this.handleClearInterval();
          return;
        }
        const data = res.data;
        if (data.scan && data.uploadJsonStr) {
          this.handleClearInterval();
          const uploadJson = JSON.parse(data.uploadJsonStr);
          if (Array.isArray(uploadJson)) {
            const fileList = this.$refs.upload.uploadFiles;
            for (const file of uploadJson) {
              this.convertFile(file);
              fileList.push(file);
              this.convertUploadFiles({ file, uploadFiles: fileList });
            }
            this.realFileList = fileList;
            this.uploadFiles = fileList;
          }
          this.visible = false;
          this.qrUrl = '';
          this.uploadCode = '';
        }
      });
    },
    getFileThumbnail,
    /**
     * 上传前处理文件
     */
    handleBeforeUpload(file) {
      if (file.size < 1) {
        Notification.error('上传文件为空');
        return false;
      }
      if (this.beforeUpload) {
        const obj = this.beforeUpload(file);
        if (appUtils.isBoolean(obj) || obj instanceof Promise) {
          return obj;
        }
        if (!obj.valid) {
          Notification.error(obj.message);
          return false;
        }
        return true;
      }
      // 默认的校验函数
      // 校验类型
      const obj = beforeUploadCheckType({ file, accept: this.accept });
      // 校验大小
      if (!obj.valid) {
        Notification.error(obj.message);
        return false;
      }
      if (!this.size) {
        return true;
      }
      if (file.size > this.size) {
        const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'];
        let size = this.size;
        // 逐级比较单位，每比较一级就除以1024
        let fileSizeUnit;
        for (const unit of FILE_SIZE_UNITS) {
          fileSizeUnit = unit;
          if (size < 1024) {
            break;
          }
          size = size / 1024;
        }
        // 过程可能会产生小数,向上取整,减少服务器校验大小失败的几率
        size = Math.ceil(size);
        Notification.error(`上传文件体积不可超过${size + fileSizeUnit}`);
        return false;
      }
      return true;
    },
    async handleFileRemove({ file }) {
      const uploadFiles = this.$refs.upload.uploadFiles;
      if (this.beforeRemove) {
        const obj = await this.beforeRemove(file, uploadFiles);
        if (appUtils.isBoolean(obj)) {
          if (obj) {
            this.coreRemove({ file, uploadFiles });
          }
          return;
        }
        if (!obj.valid) {
          Notification.error(obj.message);
          return;
        }
      }
      this.coreRemove({ file, uploadFiles });
    },
    coreRemove({ file, uploadFiles }) {
      for (let i = 0; i < uploadFiles.length; i++) {
        if (uploadFiles[i].uid === file.uid) {
          uploadFiles.splice(i, 1);
          break;
        }
      }
      this.uploadFiles = uploadFiles;
      this.convertUploadFiles && this.convertUploadFiles({ file, uploadFiles });
    },
    handleOnSuccess(res, file, uploadFiles) {
      // 隐藏loading
      Loading.service(this.loadingOption).close();
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
        return;
      }
      // 隐藏loading
      if (res.code !== 0 && res.code !== '0') {
        // 上传失败
        Notification.error(res.msg);
        uploadFiles.splice(uploadFiles.indexOf(file), 1);
        return;
      }
      // 判断是否上传了重复附件
      for (const item of uploadFiles) {
        const filePath = res.data.url;
        if (filePath === item.url) {
          Notification.error('不能上传重复的附件');
          uploadFiles.splice(uploadFiles.indexOf(file), 1);
          return;
        }
        const response = item.response;
        if (!response || res === response) {
          continue;
        }
        if (filePath === response.data.url) {
          Notification.error('不能上传重复的附件');
          uploadFiles.splice(uploadFiles.indexOf(file), 1);
          return;
        }
      }
      this.convertFile(res.data);
      this.uploadFiles = uploadFiles;
      this.convertUploadFiles && this.convertUploadFiles({ file, uploadFiles });
    },
    convertFile(file) {
      if (this.objectConverter) {
        for (const key in this.objectConverter) {
          file[this.objectConverter[key]] = file[key];
        }
      }
      return file;
    },
    /**
     * 预览文件
     */
    handlePreviewFile({ file }) {
      console.log(file);
      previewFile({ file, uploadFiles: this.$refs.upload.uploadFiles, previewMode: this.previewMode });
    },
    // 文件超出个数限制时的钩子
    handleExceed() {
      Notification.error(`最多只能上传${this.limit}个附件!`);
    },
    handleOnProgress(event, file, fileList) {
      // 显示loading
      Loading.service(this.loadingOption);
      if (this.onProgress) {
        this.onProgress(event, file, fileList);
      }
    },
    handleOnError(err, file, fileList) {
      // 隐藏loading
      Loading.service(this.loadingOption).close();
      if (this.onError) {
        this.onError(err, file, fileList);
        return;
      }
      handleError(err);
    }
  },
  watch: {
    fileList: {
      immediate: true,
      handler(fileList) {
        const ids = [];
        const realFileList = fileList.map(item => {
          // 没有url需要通过id来获取
          if (!item.url) {
            ids.push(item.id);
            item.url = '';
          }
          if (Object.prototype.hasOwnProperty.call(item, 'srcFileName')) {
            item.name = item.srcFileName;
          }
          return item;
        });
        // 调用接口，通过 url 获取文件名进行显示
        /*if (this.isGetNameFromRemote) {
          for (const item of realFileList) {
            if (item.fileName || item.name) {
              continue;
            }
            if (!item.url) {
              continue;
            }
            getFileUrlByFilePath({ filePath: item.url }).then(response => {
              const data = response.data.data[0];
              if (data) {
                this.$set(item, 'name', data.name);
              }
            });
          }
        }*/
        if (ids.length < 1) {
          this.realFileList = realFileList;
          setTimeout(() => {
            if (this.$refs.upload) {
              this.uploadFiles = this.$refs.upload.uploadFiles;
            }
          });
          return;
        }
        const obj = {
          url: this.queryUrl,
          method: this.queryMethod
        };
        if (this.queryMethod.toLowerCase() === 'get') {
          obj.params = { ids: ids.join(',') };
        } else {
          obj.data = { ids };
        }
        request(obj)
          .then(res => {
            if (res.isFail()) {
              Notification.error(res.msg);
              return;
            }
            const list = res.data;
            for (const item of list) {
              for (const file of fileList) {
                // 通过动态查询接口查出来并重组后的数据可能是字符串，通过文件查询接口查出来的可能是数字，因此这里统一做成字符串比较
                if (item.id + '' === file.id + '') {
                  Object.assign(file, item);
                  file.name = file.srcFileName;
                  this.convertFile(file);
                }
              }
            }
          })
          .finally(() => {
            this.realFileList = realFileList;
            setTimeout(() => {
              if (this.$refs.upload) {
                this.uploadFiles = this.$refs.upload.uploadFiles;
              }
            });
          });
      }
    }
  },
  computed: {
    /*headers() {
      const headers = {};
      injectToken({headers});
      injectSessionKey({headers});
      return headers;
    },*/
    hideUploadTrigger() {
      if (this.$attrs.disabled) {
        return true;
      }
      if (this.triggerVisibility === 'hide') {
        return true;
      }
      if (this.triggerVisibility === 'show') {
        return false;
      }
      if (appUtils.isEmpty(this.limit)) {
        return false;
      }
      return this.uploadFiles.length >= this.limit;
    },
    realMultiple() {
      if (this.multiple === true || this.multiple === false) {
        return this.multiple;
      }
      return !this.limit || this.limit > 1;
    }
    /*topTipWrapperClass() {
      const obj = {};
      if (this.$scopedSlots.topTip) {
        obj['x-upload-top-tip-wrapper'] = true;
      }
      return obj;
    }*/
  }
};
</script>
<style lang="scss">
.x-upload-top-tip-wrapper {
  padding-bottom: 8px;
}
.hide-upload-trigger .el-upload {
  display: none;
}
.show-file-name.x-upload {
  .el-upload-list--picture-card > .el-upload-list__item  {
    height: 140px;
  }
}
.x-upload {
  .el-upload-list--picture-card {
    font-size: 0;
    line-height: 0;
    min-height: 108px;
    & > .el-upload-list__item {
      height: auto;
      width: 100px;
      line-height: 1;
      transition: none!important;
      border: none;
      .img-wrapper {
        height: 100px;
        box-sizing: border-box;
        position: relative;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        overflow: hidden;
      }
      .file-name {
        width: 100%;
        margin-top: 5px;
        margin-bottom: 0;
        font-size: 13px;
        line-height: 1.2;
        text-align: center;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
    }
  }
  .el-upload__tip {
    width: 100%;
  }
  .el-upload--picture-card {
    width: 100px;
    height: auto;
    border: none;
    margin: 0 8px 8px 0;
    position: relative;

    .el-upload--picture-card-box{
      width: 100px;
      height: 100px;
      line-height: 100px;
      border: 1px dashed #ccc;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
  .qr-code-icon {
    position: absolute;
    top: 0;
    right: 0;
  }
  .el-upload__tip {
    margin-top: 0;
    line-height: 1;
  }

  .uploadTip{
    font-size: 12px;
    line-height: 1;
    width: 100%;
    color: red;
    margin: 5px 0;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    word-break: break-all;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
}

.qr-code-wrapper {
  position: relative;
  left: 50%;
  display: inline-block;
  transform: translateX(-50%);
  .qr-code-expire{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255,255,255,0.8);
    text-align: center;
    .qr-code-expire-wrapper{
      margin-top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>